import React from 'react';
import './DeleteConfirmationModal.css';
import { ConfigItem, ProductConfigItem } from '../api/config';

interface DeleteConfirmationModalProps {
  config: ConfigItem | ProductConfigItem;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  config,
  onConfirm,
  onCancel,
  isDeleting,
}) => {
  const isProduct = 'productId' in config;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-content delete-confirmation-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Confirm Delete</h2>
          <button
            className="close-button"
            onClick={onCancel}
            type="button"
            aria-label="Close delete confirmation"
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-description">
            You are about to permanently delete this {isProduct ? 'product' : 'global'} configuration.
            This action cannot be undone.
          </p>
          <div className="delete-summary">
            {isProduct && (
              <div className="delete-summary-row">
                <span className="delete-summary-label">Product ID:</span>
                <span className="delete-summary-value">{config.productId}</span>
              </div>
            )}
            <div className="delete-summary-row">
              <span className="delete-summary-label">Key:</span>
              <span className="delete-summary-value">{config.key}</span>
            </div>
            <div className="delete-summary-row">
              <span className="delete-summary-label">Value:</span>
              <span className="delete-summary-value">{config.value}</span>
            </div>
            <div className="delete-warning-box">
              <strong className="delete-warning-title">Warning:</strong>
              <span className="delete-warning-text">
                Deleting this configuration may impact runtime behavior immediately if it is actively read
                by services. Ensure this key is not required by critical paths before proceeding.
              </span>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="modal-pill-button modal-pill-cancel"
            onClick={onCancel}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="modal-pill-button modal-pill-delete"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;

